import { ImpulseFormUnit } from "~/tools/impulse-form";

const DEFAULT = false;

type WidgetConnectNulls = ImpulseFormUnit<boolean>;

function init(initial = DEFAULT): WidgetConnectNulls {
	return ImpulseFormUnit(initial);
}

const WidgetConnectNulls = {
	default: DEFAULT,
	init,
} as const;

export { WidgetConnectNulls };
